import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { SelectItem } from 'primeng/primeng';
import { Locale } from "../util/locale.ptbr";

@Component({
    selector: 'filter-usuario',
    template: `
        <form [formGroup]="filtro" novalidate>
            <div class="ui-g-12 ui-md-12 ui-lg-12 form-group">
                <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Nome" formControlName="nome"></form-text>
                <form-mask class="ui-g-12 ui-md-6 ui-lg-4" label="CPF" [mask]="000.000.000-00" formControlName="cpf"></form-mask>
                <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="email" formControlName="email"></form-text>
                <form-select class="ui-g-12 ui-md-6 ui-lg-4" label="Lotação" formControlName="id_lotacao" [options]="listaLotacao | formatSelectItem:'id':'nome'"></form-select>
                <form-select class="ui-g-12 ui-md-6 ui-lg-4" label="Situação" formControlName="id_situacao" [options]="listaSituacao | formatSelectItem:'id':'nome'"></form-select>
            </div>
        </form>
        <div class="ui-g-12">
        </div>
        <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 9%;">
            <button pButton type="button" label="Adicionar" class="ui-button-mandalay" icon="ui-icon-plus" [routerLink]="['./cadastrar']" ></button>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3" style="margin-right: 6%;float: right;">
            <button pButton type="button" label="Consultar" (click)="consultar($event)" class="ui-button-madison"></button>   
        </div>
    `})
export class FilterUsuarioComponent {
    constructor(public locale: Locale) { }
    @Input() filtro: FormGroup;
    @Input() listagem: DatatableComponent;
    @Input() listaSituacao: SelectItem[];
    @Input() listaLotacao: SelectItem[];

    public consultar(event: any): void {
        this.listagem.refresh(this.filtro.value)
    }
}


// WEBPACK FOOTER //
// ./src/app/usuario/usuario-filter.component.ts